import React from "react";
import StyledUnorderedList from "./UnorderedList.styled";

const ToolsList = () => (
    <StyledUnorderedList>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">SQL</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">XML</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">HTML5</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">CSS</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">XSLT</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">XPath</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">XML SAX/DOM Parser</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Java</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Spring</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Declarative Programming</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Object Oriented Programming</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">SVG</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">React/Gatsby</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Styled Components</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Bootstrap</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">JSON</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Javascript ES6+</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">RegEx</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">REST</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Hibernate</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Maven 2</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group no-bottom-border">
            <div className="list-item">
                <div className="text">Groovy</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
    </StyledUnorderedList>
);

export default ToolsList;